import { Injectable } from "@angular/core";
import { Observable, catchError } from "rxjs";
import { environment } from "src/environments/environment";
import { AppTokenService } from "./app-token.service";
import { HttpHandlerService } from "./http-handler.service";

@Injectable()
export class NetworkService {

    _httpHandler: HttpHandlerService;
    _apiUrl = environment.apiUrl;

    _resourceEndPoint = 'network';
    _headOfficeEndPoint = '/headoffices';
    _zonalOfficeEndPoint = '/zonaloffices';
    _regionalOfficeEndPoint = '/regionaloffices';
    _hubsEndPoint = '/hubs';
    _serviceCenterEndPoint = '/servicecenters';

    constructor(private httpHandler: HttpHandlerService, private appTokenService: AppTokenService) {
        this._httpHandler = httpHandler;
    }

    //#region HEAD OFFICES
    public GetAllHeadOffices(params?: any): Observable<any> {
        let full_api_url = `${this._apiUrl}${this._resourceEndPoint}${this._headOfficeEndPoint}?isactive=${params?.isactive}&pagelimit=${params?.length}&pageoffset=${params?.start}`
        if (params?.refresh) {
            full_api_url = full_api_url + `&refresh=${new Date().getTime()}`;
        }
        const request_option = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this.httpHandler.request(request_option, this.appTokenService.tokenizedResponse);
    }

    public GetAllList(params?: any): Observable<any> {
        let full_api_url = `${this._apiUrl}${this._resourceEndPoint}${this._headOfficeEndPoint}/list`
        if (params?.refresh) {
            full_api_url = full_api_url + `refresh=${new Date().getTime()}`;
        }
        const request_option = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this.httpHandler.request(request_option, this.appTokenService.tokenizedResponse);
    }

    public GetHeadOfficesById(userId: any): Observable<any> {

        const full_api_url = `${this._apiUrl}${this._resourceEndPoint}${this._headOfficeEndPoint}/${userId}`;
        const request_options = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }

    public AddHeadOffices(userData: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._resourceEndPoint}${this._headOfficeEndPoint}`;
        const request_options = this._httpHandler.prepareRequest(
            'POST',
            full_api_url,
            userData
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }

    public UpdateHeadOffices(userData: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._resourceEndPoint}${this._headOfficeEndPoint}`;
        const request_options = this._httpHandler.prepareRequest(
            'PUT',
            full_api_url,
            userData
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }


    public UpdateHeadOfficesStatus(status: boolean, headOfficeId: number): Observable<boolean> {
        const full_api_url = `${this._apiUrl}${this._resourceEndPoint}${this._headOfficeEndPoint}/status`;
        const request_options = this._httpHandler.prepareRequest(
            'PUT',
            full_api_url,
            { status, headOfficeId }
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }


    public DeleteHeadOffices(userId: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._resourceEndPoint}${this._headOfficeEndPoint}/${userId}`;
        const request_option = this._httpHandler.prepareRequest('DELETE', full_api_url, {});
        return this._httpHandler.request(request_option, this.appTokenService.tokenizedResponse)
    }

    //#endregion

    //#region ZONE OFFICE
    public GetAllZonalOffices(params?: any): Observable<any> {
        let full_api_url = `${this._apiUrl}${this._resourceEndPoint}${this._zonalOfficeEndPoint}?isactive=${params?.isactive}&pagelimit=${params?.length}&pageoffset=${params?.start}`
        if (params?.refresh) {
            full_api_url = full_api_url + `refresh=${new Date().getTime()}`;
        }
        const request_option = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this.httpHandler.request(request_option, this.appTokenService.tokenizedResponse);
    }

    public GetZonalOfficesById(userId: any): Observable<any> {

        const full_api_url = `${this._apiUrl}${this._resourceEndPoint}${this._zonalOfficeEndPoint}/${userId}`;
        const request_options = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }

    public AddZonalOffices(userData: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._resourceEndPoint}${this._zonalOfficeEndPoint}`;
        const request_options = this._httpHandler.prepareRequest(
            'POST',
            full_api_url,
            userData
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }

    public UpdateZonalOffices(userData: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._resourceEndPoint}${this._zonalOfficeEndPoint}`;
        const request_options = this._httpHandler.prepareRequest(
            'PUT',
            full_api_url,
            userData
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }


    public UpdateZonalOfficesStatus(status: boolean, headOfficeId: number): Observable<boolean> {
        const full_api_url = `${this._apiUrl}${this._resourceEndPoint}${this._zonalOfficeEndPoint}/status`;
        const request_options = this._httpHandler.prepareRequest(
            'PUT',
            full_api_url,
            { status, headOfficeId }
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }


    public DeleteZonalOffices(userId: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._resourceEndPoint}${this._zonalOfficeEndPoint}/${userId}`;
        const request_option = this._httpHandler.prepareRequest('DELETE', full_api_url, {});
        return this._httpHandler.request(request_option, this.appTokenService.tokenizedResponse)
    }

    //#endregion

    //#region REGIONAL OFFICE
    public GetAllRegionalOffices(params?: any): Observable<any> {
        let full_api_url = `${this._apiUrl}${this._resourceEndPoint}${this._regionalOfficeEndPoint}?isactive=${params?.isactive}&pagelimit=${params?.length}&pageoffset=${params?.start}`
        if (params?.refresh) {
            full_api_url = full_api_url + `refresh=${new Date().getTime()}`;
        }
        const request_option = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this.httpHandler.request(request_option, this.appTokenService.tokenizedResponse);
    }

    public GetRegionalOfficesById(userId: any): Observable<any> {

        const full_api_url = `${this._apiUrl}${this._resourceEndPoint}${this._regionalOfficeEndPoint}/${userId}`;
        const request_options = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }

    public AddRegionalOffices(userData: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._resourceEndPoint}${this._regionalOfficeEndPoint}`;
        const request_options = this._httpHandler.prepareRequest(
            'POST',
            full_api_url,
            userData
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }

    public UpdateRegionalOffices(userData: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._resourceEndPoint}${this._regionalOfficeEndPoint}`;
        const request_options = this._httpHandler.prepareRequest(
            'PUT',
            full_api_url,
            userData
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }


    public UpdateRegionalOfficesStatus(status: boolean, headOfficeId: number): Observable<boolean> {
        const full_api_url = `${this._apiUrl}${this._resourceEndPoint}${this._regionalOfficeEndPoint}/status`;
        const request_options = this._httpHandler.prepareRequest(
            'PUT',
            full_api_url,
            { status, headOfficeId }
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }


    public DeleteRegionalOffices(userId: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._resourceEndPoint}${this._regionalOfficeEndPoint}/${userId}`;
        const request_option = this._httpHandler.prepareRequest('DELETE', full_api_url, {});
        return this._httpHandler.request(request_option, this.appTokenService.tokenizedResponse)
    }

    //#endregion

    //#region HUBS
    public GetAllHubsOffices(params?: any): Observable<any> {
        let full_api_url = `${this._apiUrl}${this._resourceEndPoint}${this._hubsEndPoint}?isactive=${params?.isactive}&pagelimit=${params?.length}&pageoffset=${params?.start}`
        if (params?.refresh) {
            full_api_url = full_api_url + `refresh=${new Date().getTime()}`;
        }
        const request_option = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this.httpHandler.request(request_option, this.appTokenService.tokenizedResponse);
    }

    public GetHubsOfficesById(userId: any): Observable<any> {

        const full_api_url = `${this._apiUrl}${this._resourceEndPoint}${this._hubsEndPoint}/${userId}`;
        const request_options = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }

    public AddHubsOffices(userData: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._resourceEndPoint}${this._hubsEndPoint}`;
        const request_options = this._httpHandler.prepareRequest(
            'POST',
            full_api_url,
            userData
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }

    public UpdateHubsOffices(userData: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._resourceEndPoint}${this._hubsEndPoint}`;
        const request_options = this._httpHandler.prepareRequest(
            'PUT',
            full_api_url,
            userData
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }


    public UpdateHubsOfficesStatus(status: boolean, headOfficeId: number): Observable<boolean> {
        const full_api_url = `${this._apiUrl}${this._resourceEndPoint}${this._hubsEndPoint}/status`;
        const request_options = this._httpHandler.prepareRequest(
            'PUT',
            full_api_url,
            { status, headOfficeId }
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }


    public DeleteHubsOffices(userId: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._resourceEndPoint}${this._hubsEndPoint}/${userId}`;
        const request_option = this._httpHandler.prepareRequest('DELETE', full_api_url, {});
        return this._httpHandler.request(request_option, this.appTokenService.tokenizedResponse)
    }

    //#endregion

    //#region SERVICE CENTER
    public GetAllServiceCenters(params?: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._resourceEndPoint}${this._serviceCenterEndPoint}?isactive=${params?.isactive}&pagelimit=${params?.length}&pageoffset=${params?.start}`
        const request_option = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this.httpHandler.request(request_option, this.appTokenService.tokenizedResponse);
    }

    public GetAllListServiceCenters(params?: any): Observable<any> {
        let full_api_url = `${this._apiUrl}${this._resourceEndPoint}${this._serviceCenterEndPoint}/list?pagelimit=${params?.length}&pageoffset=${params?.start}`
        if (params?.refresh) {
            full_api_url = full_api_url + `refresh=${new Date().getTime()}`;
        }
        const request_option = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this.httpHandler.request(request_option, this.appTokenService.tokenizedResponse);
    }

    public GetServiceCentersById(userId: any): Observable<any> {

        const full_api_url = `${this._apiUrl}${this._resourceEndPoint}${this._serviceCenterEndPoint}/${userId}?refresh=${new Date().getTime()}`;
        const request_options = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }

    public AddServiceCenters(userData: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._resourceEndPoint}${this._serviceCenterEndPoint}`;
        const request_options = this._httpHandler.prepareRequest(
            'POST',
            full_api_url,
            userData
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }

    public UpdateServiceCenters(userData: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._resourceEndPoint}${this._serviceCenterEndPoint}`;
        const request_options = this._httpHandler.prepareRequest(
            'PUT',
            full_api_url,
            userData
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }


    public UpdateServiceCenterStatus(status: boolean, headOfficeId: number): Observable<boolean> {
        const full_api_url = `${this._apiUrl}${this._resourceEndPoint}${this._serviceCenterEndPoint}/status`;
        const request_options = this._httpHandler.prepareRequest(
            'PUT',
            full_api_url,
            { status, headOfficeId }
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }


    public DeleteServiceCenters(userId: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._resourceEndPoint}${this._serviceCenterEndPoint}/${userId}`;
        const request_option = this._httpHandler.prepareRequest('DELETE', full_api_url, {});
        return this._httpHandler.request(request_option, this.appTokenService.tokenizedResponse)
    }

    //#endregion
}



